import React from "react";
import { Outlet } from "react-router-dom";
import "./userDashboard.css";

function UserDashoard() {
    return (
        <div className="userDashboard">
            <h1>Welcome to User Dashboard</h1>
            <Outlet /> {/* This will dynamically load either UserReports or UserVehicleDetails */}
        </div>
    );
}

export default UserDashoard;
